import { render } from "./ClientListPage.vue?vue&type=template&id=ac149fce"
import script from "./ClientListPage.vue?vue&type=script&lang=js"
export * from "./ClientListPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wallace/Desktop/projects/virtap/virtap-webapp-support/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__